
import AdsApi from '../libs/ads-request/ads-api';
import AContainer from './AContainer.vue';
import Conditions from '../views/notice/ConditionsText.vue';
import EventBus from '../events';

export default {
  name: 'NoticeOfPrivacy',
  components: {
    AContainer,
    Conditions,
  },
  props: {
    email: {
      type: String,
      required: true,
    },
    initialStep: {
      type: Number,
      required: true,
    },
    superOrderId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    reject: false,
    step: 1,
    noticeOfPrivacy: false,
    dataTransfer: false,
  }),
  computed: {
    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    isThemeVolkswagen() {
      return this.$session.get('brand') === 'volkswagen';
    },
    style() {
      let style = {};

      switch (this.$session.get('brand')) {
        case 'volkswagen':
          style = { height: this.mobile ? 'calc(100vh - 308px)' : 'calc(100vh - 203px)' };
          break;
        case 'audi':
          style = { height: this.mobile ? 'calc(100vh - 318px)' : 'calc(100vh - 210px)' };
          break;
        case 'seat':
          style = { height: this.mobile ? 'calc(100vh - 316px)' : 'calc(100vh - 210px)' };
          break;
        default:
          style = { height: this.mobile ? 'calc(100vh - 310px)' : 'calc(100vh - 140px)' };
          break;
      }

      return style;
    },
    disableButtonAccept() {
      return (
        (this.noticeOfPrivacy === false && this.step === 2)
        || (!this.dataTransfer && this.step === 2)
      );
    },
  },
  watch: {
    initialStep(val) {
      this.step = val;
    },
    noticeOfPrivacy(val) {
      this.updateNoticePrivacy(1, val ? 1 : 0);
    },
    dataTransfer(val) {
      this.updateNoticePrivacy(3, val ? 1 : 0);
    },
  },
  mounted() {
    this.dataTransfer = this.$session.get('transferData') === 1;
    this.noticeOfPrivacy = this.$session.get('privacy') === 1;
  },
  methods: {
    nextStep() {
      if (this.step === 1) this.updateTermsService();
      if (this.step === 2) {
        this.loaderShow('Validando sesión');
        this.$emit('accepted', this.email);
      }
      this.step += 1;
    },
    updateTermsService() {
      AdsApi.updateTermsService(this.email, this.superOrderId)
        .then((res) => {
          const response = res.data;
          if (!response.success) {
            throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
          }
        })
        .catch((err) => {
          this.alertShow(err, 'error');
          this.step = 1;
        });
    },
    updateNoticePrivacy(action, value) {
      this.loaderShow('Actualizando');
      AdsApi.updateNoticePrivacy(this.email, this.superOrderId, action, value)
        .then((res) => {
          const responseData = res.data;
          const actionName = action === 1 ? 'privacy' : 'transferData';
          this.$session.set(actionName, value);
          this.$emit('updated-privacy-transfer', { privacy: this.$session.get('privacy'), transferData: this.$session.get('transferData') });
          EventBus.$emit('privacy-updated');
          if (!responseData.success) {
            throw new Error(`[${responseData.errorCode}] ${responseData.errorDescription}`);
          }
        })
        .catch((err) => {
          this.alertShow(err, 'error');
        })
        .finally(this.loaderHide);
    },
    redirectToLogin() {
      try {
        this.logOutLogic();
      } catch (error) {
        this.alertShow(error, 'error');
      }
    },
  },
};
